/* eslint-disable camelcase */
import { IGradFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { LineJoin } from '@tencent/alloy-renderer';
import { IEndInfo } from '@src/slide/infrastructure/module/dependent/line-info/endStyle';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import  { BorderSketchType } from '@src/slide/domain/ui-model/element-modeles/property/border/constants';
import type { ICustomPath } from '@tencent/alloy-graphics';
import type { CompoundType } from '@tencent/alloy-renderer-adapter';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

/**
 * 属性的key
 */
export const BORDER_KEY = 'border-color';

export enum ILineCap {
    /** 无线端. */
    Butt = 'flat',
    /** 圆形. */
    Round = 'rnd',
    /** 方形. */
    Square = 'sq'
}
export interface IBorderProperty {
    /**
     * 获取填充的类型。当元素边框类型不同时，fillType为undefined
     */
    getBorderType(): BorderType | undefined;

    /**
     * 获取元素所有填充信息集合。
     */
    getBorderInfo(): IBorderInfo | null | undefined ;

    /**
     * 更新元素当前的边框信息。
     * @param borderSet 待更新的边框数据。
     * @param onlyUIChange 是否只更新UI。
     * @param isPreviewColor 是否只预览颜色。边框可以分别预览样式和颜色。
     */
    updateCurrentBorder(borderSet: IBorderInfo, onlyUIChange?: boolean, isPreviewColor?: boolean): void;

    /**
     * 对border的特殊情况进行处理
     */
    handleBorderSpecial(borderSet: IBorderInfo, curBorderSet?: IBorderInfo | null, borderType?: BorderType): void

    /**
     * 刷新 多选图形|组合 合并后的效果值
     * 多选图形、组合的属性是综合所有子元素而来的。基于性能考虑，加入缓存，只在必要时重新获取更新缓存
     */
    refreshMergePropertyValCache(): IBorderInfo | null | undefined
}

export interface ITableBorderProperty extends IBorderProperty {
    /**
     * 获取表格的边框信息，包括颜色和样式。
     */
    getTableBorderInfo(): ITableBorderInfo;

    /**
     * 更新表格的边框信息（颜色、样式、粗细）。
     */
    updateTableBorderInfo(tableBorderInfo: IBorderInfo): void;

    /**
     * 更新表格的边框样式。
     */
    updateTableBorderStyle(borderStyle: ITableBorderStyle): void

    /**
     * 清理表格边框样式
     */
    clearTableBorderStyle(): void;
}


export type IBorderInfo = {
    width?: number;   // 线条宽度
    style?: string | null;
    color?: string | null;
    tdColor?: ITDColor | null;
    colorValue?: string | null;
    gradFill?: IGradFill | null
    headEnd?: IEndInfo | null;
    tailEnd?: IEndInfo | null;
    linecap?: ILineCap;   // 线端类型
    linejoin?: LineJoin; // 连接类型
    sketchStyle?: ISketchStyle | null;
    noFill?: number // 文本边框选择无边框时 为1
    compoundType?: CompoundType | null; // 边框复合类型
};

export enum BorderType {
    NoFill = 'noFill',          // 无边框
    SolidFill = 'solidFill',    // 纯色边框
    GradualFill = 'gradFill',   // 渐变色边框
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IBaseBorderInfo {}

/**
 * 表格边框样式
 */
export interface ITableBorderStyle {
    border_all: boolean;    // 所有边框
    border_none: boolean;   // 无边框
    border_outer: boolean;  // 外部边框
    border_inner: boolean;  // 内部边框
    border_horizontal: boolean; // 水平边框
    border_vertical: boolean;   // 垂直边框
    border_top: boolean;    // 顶部边框
    border_right: boolean;  // 右侧边框
    border_bottom: boolean; // 底部边框
    border_left: boolean;   // 左侧边框
}

export interface ITableBorderInfo {
    borderColor: IBorderInfo | undefined | null;
    borderStyle: ITableBorderStyle;
}

export interface ISketchStyle {
    type?: BorderSketchType;
    bgShape?: ShapeType;
    controlValues?: Array<number>;
    pathList?: Array<ICustomPath>;
    customGeom?: {
        pathList: Array<ICustomPath>
    }
}
